import type { ColumnsType } from "antd/es/table";
import { Button } from "antd";
import { langPage, langTableColumns } from "../../../locales";
import { FormConfigType } from "../../../components/editForm";

export const DEFAULT_QUERY_DATA = {
    Email: null,
    MemberId: null,
    MemberEmail: null
};

export const generateQueryFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: '持卡人邮箱',
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: '用户邮箱',
            type: "input",
            field: "MemberEmail",
            allowClear: true,
        },
        {
            title: langPage?.card?.memberId,
            type: "input",
            field: "MemberId",
            allowClear: true,
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    const { loading, operationRef} = props;
    return [
        {
            title: '邮箱',
            dataIndex: "Email",
        },
        {
            title: 'FirstName',
            dataIndex: "FirstName",
        },
        {
            title: 'LastName',
            dataIndex: "LastName",
        },
        {
            title: '手机号',
            dataIndex: "PhoneNumber",
        },
        {
            title: '国家',
            dataIndex: "Country",
        },
        {
            title: '城市',
            dataIndex: "City",
        },
        {
            title: '州、县、省或地区',
            dataIndex: "State",
        },
        {
            title: '地址行 1',
            dataIndex: "Line1",
        },
        {
            title: '邮编',
            dataIndex: "PostalCode",
        },
        {
            title: '卡片数量',
            dataIndex: "CardsCount",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
        {
            title: "操作",
            dataIndex: "ops",
            width: 80,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link"
                            onClick={() => operationRef?.current?.changeVisible(row, 'update')}
                        >编辑</Button>
                    </div>
                )
            }
        }
    ]
}


export const generateOperationFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: '邮箱',
            type: "input",
            field: "Email",
        },
        {
            title: '电话',
            type: "input",
            field: "PhoneNumber",
        },
    ];
}

